module.exports = __webpack_public_path__ + "img/cnca.998dfa8c.png";